import { PaletteOptions } from '@material-ui/core/styles/createPalette';

export const palette: PaletteOptions = {
  primary: {
    light: '#FFE4CC',
    main: '#FF7800',
    dark: '#F15A24',
    contrastText: '#fff',
  },
  secondary: {
    light: '#45476D6E',
    main: '#1B2042',
    dark: '#45476D',
  },
  error: {
    main: '#FF1D15',
  },
  success: {
    main: '#00BF4C',
  },
  warning: {
    main: '#FFA07A',
  },
  text: {
    primary: '#1A1A1A',
    secondary: '#000000',
  },
  grey: {
    100: '#F0F0F0',
    200: '#F6F6F6',
    300: '#E8E8E8',
    400: '#C4C4C4',
    500: '#D8D8D8',
    600: '#B6B6B6',
    900: '#444444',
  },
  common: {
    white: '#fff',
  },
};
